import { themeProvider } from '@swipejobs/frontend-theme-provider';
import styled from 'styled-components';

export const RequiredMarkText = styled.span`
  color: ${() => themeProvider.getColors().text.errorTextMessage};
`;



// WEBPACK FOOTER //
// ./src/components/required/styles.tsx